var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_240_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5056 3.31314C33.6772 3.31314 27.0021 5.33804 21.3245 9.13177C15.6469 12.9255 11.2217 18.3177 8.60855 24.6264C5.99543 30.9352 5.31171 37.8772 6.64388 44.5745C7.97604 51.2718 11.2642 57.4237 16.0927 62.2522C20.9211 67.0807 27.0729 70.369 33.7701 71.7012C40.4673 73.0334 47.4092 72.3496 53.7178 69.7365C60.0265 67.1233 65.4186 62.6981 69.2123 57.0203C73.0059 51.3426 75.0308 44.6674 75.0308 37.8389C75.0308 28.6821 71.3933 19.9003 64.9186 13.4255C58.4439 6.95066 49.6623 3.31314 40.5056 3.31314V3.31314ZM31.2941 54.5281H23.7145V30.0387H31.2941V54.5281ZM27.4684 26.8318C26.5741 26.8384 25.6979 26.5792 24.9511 26.0871C24.2043 25.595 23.6205 24.8922 23.2737 24.0678C22.9268 23.2434 22.8327 22.3346 23.0031 21.4566C23.1736 20.5786 23.6009 19.771 24.231 19.1363C24.8611 18.5016 25.6654 18.0682 26.5421 17.8913C27.4188 17.7144 28.3283 17.8019 29.1552 18.1426C29.9821 18.4833 30.6892 19.062 31.1868 19.8051C31.6844 20.5483 31.95 21.4225 31.95 22.3169C31.9539 23.5098 31.4841 24.6554 30.6437 25.502C29.8033 26.3486 28.6613 26.8269 27.4684 26.8318ZM59.7016 54.5281H52.1592V41.6739C52.1592 38.1483 50.8194 36.1803 48.0321 36.1803C44.9979 36.1803 43.4124 38.2306 43.4124 41.6739V54.5294H36.1409V30.0387H43.4111V33.3372C44.1872 32.0834 45.2748 31.0518 46.5679 30.343C47.861 29.6342 49.3156 29.2722 50.7902 29.2924C55.9835 29.2924 59.7003 32.4635 59.7003 39.022V54.5281H59.7016Z",
    fill: "url(#paint0_linear_240_470)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_240_470",
    x: 2.98047,
    y: 2.31314,
    width: 75.0508,
    height: 75.0515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_470",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_470",
    x1: -130.118,
    y1: 183.537,
    x2: -81.2983,
    y2: 232.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a0cbbaf6d212f26d59997ccd99bc46a5.svg";
export { ForwardRef as ReactComponent };